/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, CancelToken } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
import { makeCodedException, makeContent } from 'utils';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

export interface IOnboardingWizardCompanyProfileApi {
    companyProfileGet(cancelToken?: CancelToken): AxiosPromise<CompanyProfileResponseModel | undefined>;
    companyProfileUpdateWithLogo(model: Blob, cancelToken?: CancelToken): AxiosPromise<string | undefined>;
    companyProfileUpdate(model: CompanyProfileRequestModel, cancelToken?: CancelToken): AxiosPromise<string | undefined>;
    verifyAddress(model: CompanyAddressModel, cancelToken?: CancelToken): AxiosPromise<CompanyAddressVerificationModel | undefined>;
    addressVerificationRequired(cancelToken?: CancelToken): AxiosPromise<boolean>;
}

export const BASE_URL_TOKEN_OnboardingWizardCompanyProfileApi = symbolToken<string>('BASE_URL_TOKEN', false);

@injectable()
export class OnboardingWizardCompanyProfileApi implements IOnboardingWizardCompanyProfileApi {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@inject(BASE_URL_TOKEN_OnboardingWizardCompanyProfileApi) @optional() private readonly baseUrl = "") {
    }

    companyProfileGet(cancelToken?: CancelToken): AxiosPromise<CompanyProfileResponseModel | undefined> {
        let url_ = "/app/api/onboarding-wizard/CompanyProfileGet";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<CompanyProfileResponseModel | undefined>(options_));
    }

    companyProfileUpdateWithLogo(model: Blob, cancelToken?: CancelToken): AxiosPromise<string | undefined> {
        let url_ = "/app/api/onboarding-wizard/CompanyProfileUpdateWithLogo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = model;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "multipart/form-data",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<string | undefined>(options_));
    }

    companyProfileUpdate(model: CompanyProfileRequestModel, cancelToken?: CancelToken): AxiosPromise<string | undefined> {
        let url_ = "/app/api/onboarding-wizard/CompanyProfileUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = model;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<string | undefined>(options_));
    }

    verifyAddress(model: CompanyAddressModel, cancelToken?: CancelToken): AxiosPromise<CompanyAddressVerificationModel | undefined> {
        let url_ = "/app/api/onboarding-wizard/VerifyAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = model;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<CompanyAddressVerificationModel | undefined>(options_));
    }

    addressVerificationRequired(cancelToken?: CancelToken): AxiosPromise<boolean> {
        let url_ = "/app/api/onboarding-wizard/AddressVerificationRequired";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<boolean>(options_));
    }
}

export interface CompanyProfileModel {
    companyName: string;
    adminPhone?: string | undefined;
    companyStreetAddress: string;
    companyCountry: string;
    companyStateCode: string;
    companyCity: string;
    companyZipCode: string;
    einOrBn?: string | undefined;
    isCompanyAddressVerified: boolean;
}

export interface CompanyProfileResponseModel extends CompanyProfileModel {
    companyLogo?: string | undefined;
}

export interface CompanyProfileRequestModel extends CompanyProfileModel {
    companyLogo?: any | undefined;
}

export interface CompanyAddressVerificationModel {
    result: boolean;
    errorMessage?: string | undefined;
    suggestedAddresses?: CompanyAddressModel[] | undefined;
}

export interface CompanyAddressModel {
    street?: string | undefined;
    unit?: string | undefined;
    country?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
}
